import { create } from 'zustand';

/**
 * Tiny shared store the admin uses to force the storefront LivePreviewPanel
 * iframe to reload. After any homepage-related mutation succeeds (layout
 * reorder, content edit, festival theme switch) the page calls `bump()` and
 * the LivePreviewPanel (mounted side-by-side) reloads the iframe so the admin
 * sees their change immediately — no need to switch tabs or hit refresh.
 *
 * Why a global store instead of prop drilling: the preview panel is rendered
 * inside the page component that owns the mutation, so prop drilling works,
 * but multiple mutations in one page (and future ones) all need to trigger
 * the same reload. The store keeps that contract clean.
 */
interface PreviewState {
  /** Incremented after every save — LivePreviewPanel watches it via subscribe(). */
  version: number;
  bump: () => void;
}

export const usePreviewStore = create<PreviewState>((set) => ({
  version: 0,
  bump: () => set((s) => ({ version: s.version + 1 })),
}));
